import { getShortUrlParams, writeShortUrlParams } from '@intelligence/services/common';
import { getCurrentSearchParamsString } from '@intelligence/v3/utils/urlSearchParams';
import { isEmpty } from '@intelligence/v3/utils/common';

/**
 * 短连接id对应的数据
 */
export interface IFilterShortIdContext {
  /** filter筛选器数据 */
  filter: IRecord;
  /** 其他扩展信息 */
  [key: string]: any;
}

/**
 * 获取短连接id（url查询参数的filter_short_id字段）对应的筛选器value
 */
export const analysisFilterShortId = async (): Promise<IFilterShortIdContext> => {
  const searchParams = new URLSearchParams(getCurrentSearchParamsString());
  const filterShortId = searchParams.get('filter_short_id') || '';

  if (isEmpty(filterShortId)) {
    return { filter: {} };
  }

  try {
    const res = await getShortUrlParams({ key: filterShortId });
    const data = JSON.parse(res?.data?.params);
    const filter = data?.filter || {};
    return { ...data, filter };
  } catch (error) {
    // TODO: 补充url短连接解析异常日志上报功能
    console.error(error);
    return { filter: {} };
  }
};

/**
 * 更新短连接id（url查询参数的filter_short_id字段）
 * @param filter 筛选器数据
 * @param params 最新的数据
 */
const writeFilterShortId = async (filter: IRecord, params: IRecord) => {
  try {
    const res = await writeShortUrlParams({
      system_type: 'intelligence',
      params: JSON.stringify({ ...params, filter: filter || {} }),
    });
    return res?.data?.key || '';
  } catch (error) {
    console.error(error);
    return '';
  }
};
